import styled from 'styled-components';
import { LAYOUT_HEIGHT_HEADER } from '@/main/services/constants';
import { formatAsPx } from '@/main/services/utilsNumber';

const heightHeader = formatAsPx(LAYOUT_HEIGHT_HEADER);

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 1rem 0 0;
  height: calc(100vh - ${heightHeader});
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    gap: 1rem;

    > button {
      max-width: 100%;
    }
  }
`;

export const ImageError = styled.img`
  width: 100%;
  max-width: 500px;
  margin: 0 0 -2rem;
`;
export const MessageError = styled.h4`
  margin: 0 0 2rem;
  text-align: center;
`;

